import { render, staticRenderFns } from "./LinkedInAds.vue?vue&type=template&id=0b27a275&scoped=true&"
import script from "./LinkedInAds.vue?vue&type=script&lang=js&"
export * from "./LinkedInAds.vue?vue&type=script&lang=js&"
import style0 from "./LinkedInAds.vue?vue&type=style&index=0&id=0b27a275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b27a275",
  null
  
)

export default component.exports